// src/api/master.api.js

import api from './axios';

// ==================== CASE CATEGORY ====================
export const getCaseCategoriesApi = (page = 1, limit = 10, q = '') =>
    api.get('/case/setting/caseCategory', { params: { page, limit, q } });

export const createCaseCategoryApi = (payload) =>
    api.post('/case/setting/caseCategory', payload);

export const updateCaseCategoryApi = (categoryId, payload) =>
    api.put(`/case/setting/caseCategory/${categoryId}`, payload);

export const deleteCaseCategoryApi = (categoryId) =>
    api.delete(`/case/setting/caseCategory/${categoryId}`);

// ==================== CASE TYPE ====================
export const getCaseTypesApi = (page = 1, limit = 10, q = '') =>
    api.get('/case/setting/caseType', { params: { page, limit, q } });

export const getCaseTypesByCategoryApi = (categoryId) =>
    api.get(`/case/setting/caseType/${categoryId}`);

export const createCaseTypeApi = (payload) =>
    api.post('/case/setting/caseType', payload);

export const updateCaseTypeApi = (caseTypeId, payload) =>
    api.put(`/case/setting/caseType/${caseTypeId}`, payload);

export const deleteCaseTypeApi = (caseTypeId) =>
    api.delete(`/case/setting/caseType/${caseTypeId}`);

// ==================== JUSTICE NAME ====================
export const getJusticeNamesApi = (page = 1, limit = 10, q = '') =>
    api.get('/case/setting/justiceName', { params: { page, limit, q } });

export const createJusticeNameApi = (payload) =>
    api.post('/case/setting/justiceName', payload);

export const updateJusticeNameApi = (justiceId, payload) =>
    api.put(`/case/setting/justiceName/${justiceId}`, payload);

export const deleteJusticeNameApi = (justiceId) =>
    api.delete(`/case/setting/justiceName/${justiceId}`);

// ==================== RELATED LAW OFFICER ====================
export const getLawOfficersApi = (page = 1, limit = 10, q = '') =>
    api.get('/case/setting/relatedLawOfficer', { params: { page, limit, q } });

export const createLawOfficerApi = (payload) =>
    api.post('/case/setting/relatedLawOfficer', payload);

export const updateLawOfficerApi = (lawOfficerId, payload) =>
    api.put(`/case/setting/relatedLawOfficer/${lawOfficerId}`, payload);

export const deleteLawOfficerApi = (lawOfficerId) =>
    api.delete(`/case/setting/relatedLawOfficer/${lawOfficerId}`);

// ==================== RELATED LAW OFFICER NAME ====================
export const getLawOfficerNamesApi = (page = 1, limit = 10, q = '') =>
    api.get('/case/setting/relatedLawOfficerName', { params: { page, limit, q } });

export const getLawOfficerNamesByOfficerApi = (lawOfficerId) =>
    api.get(`/case/setting/relatedLawOfficerName/${lawOfficerId}`);

export const createLawOfficerNameApi = (payload) =>
    api.post('/case/setting/relatedLawOfficerName', payload);

export const updateLawOfficerNameApi = (officerNameId, payload) =>
    api.put(`/case/setting/relatedLawOfficerName/${officerNameId}`, payload);

export const deleteLawOfficerNameApi = (officerNameId) =>
    api.delete(`/case/setting/relatedLawOfficerName/${officerNameId}`);

// ==================== RESPONDENT LIST ====================
export const getRespondentsApi = (page = 1, limit = 10, q = '') =>
    api.get('/case/setting/respondentList', { params: { page, limit, q } });

export const createRespondentApi = (payload) =>
    api.post('/case/setting/respondentList', payload);

export const updateRespondentApi = (respondentId, payload) =>
    api.put(`/case/setting/respondentList/${respondentId}`, payload);

export const deleteRespondentApi = (respondentId) =>
    api.delete(`/case/setting/respondentList/${respondentId}`);

// ==================== DISTRICT ====================
export const getDistrictsApi = () =>
    api.get('/case/setting/district');

// ==================== COURT TYPE ====================
export const getCourtTypesApi = () =>
    api.get('/case/setting/courtType');

export const getHighCourtTypeApi = () =>
    api.get('/case/setting/highCourtType');

// ==================== CASE ENTRY ====================
export const createHighCourtEntryApi = (payload) =>
    api.post('/case/highCourtEntry', payload);

export const updateHighCourtEntryApi = (caseEntryId, payload) =>
    api.put(`/case/highCourtEntry/${caseEntryId}`, payload);

export const createAppealCourtEntryApi = (payload) =>
    api.post('/case/appealCourtEntry', payload);

export const updateAppealCourtEntryApi = (caseEntryId, payload) =>
    api.put(`/case/appealCourtEntry/${caseEntryId}`, payload);

export const getCaseNumberByTypeApi = (caseTypeId) =>
    api.get(`/case/caseEntry/caseNumber/${caseTypeId}`);

export const updateCaseEntryCommentApi = (payload) =>
    api.put('/case/case-entry/comment', payload);

// ==================== PLAINTIFFS & DEFENDANTS ====================
export const getPlaintiffsByCaseEntryApi = (caseEntryId) =>
    api.get(`/case/plaintiffs/${caseEntryId}`);

export const createPlaintiffApi = (payload) =>
    api.post('/case/plaintiff', payload);

export const deletePlaintiffApi = (plaintiffId) =>
    api.delete(`/case/plaintiff/${plaintiffId}`);

export const getDefendantsByCaseEntryApi = (caseEntryId) =>
    api.get(`/case/defendants/${caseEntryId}`);

export const createDefendantApi = (payload) =>
    api.post('/case/defendant', payload);

export const deleteDefendantApi = (defendantId) =>
    api.delete(`/case/defendant/${defendantId}`);

// ==================== LAW OFFICER ASSIGNMENT ====================
export const getAssignResponsibleOfficersApi = (caseEntryId) =>
    api.get(`/case/assign-responsible-officers/${caseEntryId}`);

export const assignLawOfficerApi = (payload) =>
    api.post('/case/assign-law-officer', payload);

export const deleteAssignLawOfficerApi = (lawId) =>
    api.delete(`/case/assign-law-officer/${lawId}`);

export const createResponsibleOfficersApi = (payload) =>
    api.post('/case/responsibleofficers', payload);

export const getResponsibleOfficersApi = (caseEntryId) =>
    api.get(`/case/responsible-officers/${caseEntryId}`);

// ==================== HEARING DATES ====================
export const getHearingDatesByCaseEntryApi = (caseEntryId) =>
    api.get(`/case/hearing-dates/${caseEntryId}`);

export const createHearingDateApi = (payload) =>
    api.post('/case/hearing-dates', payload);

export const deleteHearingDateApi = (hearingId) =>
    api.delete(`/case/hearing-dates/${hearingId}`);

// ==================== DOCUMENTS ====================
export const getDocumentsByCaseEntryApi = (caseEntryId) =>
    api.get(`/case/documents/${caseEntryId}`);

export const addDocumentApi = (payload) =>
    api.post('/case/add-document', payload);

export const deleteDocumentApi = (fileId) =>
    api.delete(`/case/delete-document/${fileId}`);

// ==================== FINAL RESULT / JUDGMENT ====================
export const getFinalResultApi = (caseEntryId) =>
    api.get(`/case/final-result/${caseEntryId}`);

export const createFinalResultApi = (payload) =>
    api.post('/case/final-result', payload);

// ==================== CASE REPORTS ====================
export const getSingleCaseViewApi = (caseId) =>
    api.get(`/case/reports/single-case/${caseId}`);

export const getCaseReportByIdApi = (caseEntryId) =>
    api.get('/case/reports/singlecasereport', { params: { case_entry_id: caseEntryId } });

export const getAllCaseReportApi = () =>
    api.get('/case/reports/allcasereport');

export const getRunningDistrictCaseReportApi = () =>
    api.get('/case/reports/running-district-case-report');

export const getCloseDistrictCaseReportApi = () =>
    api.get('/case/reports/close-district-case-report');

export const getAllHighCaseReportApi = () =>
    api.get('/case/reports/allhighcasereport');

export const getRunningHighCaseReportApi = () =>
    api.get('/case/reports/running-high-case-report');

export const getCloseHighCaseReportApi = () =>
    api.get('/case/reports/close-high-case-report');

export const getAllTribunalCaseReportApi = () =>
    api.get('/case/reports/alltribunalcasereport');

export const getRunningTribunalCaseReportApi = () =>
    api.get('/case/reports/running-tribunal-case-report');

export const getCloseTribunalCaseReportApi = () =>
    api.get('/case/reports/close-tribunal-case-report');

export const getAllAppealCaseReportApi = () =>
    api.get('/case/reports/allappealcasereport');

export const getRunningAppealCaseReportApi = () =>
    api.get('/case/reports/running-appeal-case-report');

export const getCloseAppealCaseReportApi = () =>
    api.get('/case/reports/close-appeal-case-report');

export const getImportantRunningCaseApi = () =>
    api.get('/case/reports/importantrunningcase');

// ==================== LAWYERS MANAGEMENT ====================
export const getLawyersApi = (lawyerType) =>
    api.get('/case/lawyers', { params: { lawyer_type: lawyerType } });

export const createLawyerApi = (payload) =>
    api.post('/case/lawyers', payload);

export const updateLawyerApi = (lawyerId, payload) =>
    api.put(`/case/lawyers/${lawyerId}`, payload);

export const deleteLawyerApi = (lawyerId) =>
    api.delete(`/case/lawyers/${lawyerId}`);

// ==================== CASE SUMMARY ====================
export const getCaseSummaryApi = (params) =>
    api.get('/case/case-summary', { params });

export const createCaseSummaryApi = (payload) =>
    api.post('/case/case-summary', payload);

export const deleteCaseSummaryApi = (caseId) =>
    api.delete(`/case/case-summary/${caseId}`);

// ==================== DASHBOARD & NOTIFICATIONS ====================
export const getDashboardApi = () =>
    api.get('/case/dashboard');

export const getNotificationApi = () =>
    api.get('/case/notification');

// ==================== EXPORT ALL ====================
export default {
    // Case Category
    getCaseCategoriesApi,
    createCaseCategoryApi,
    updateCaseCategoryApi,
    deleteCaseCategoryApi,

    // Case Type
    getCaseTypesApi,
    getCaseTypesByCategoryApi,
    createCaseTypeApi,
    updateCaseTypeApi,
    deleteCaseTypeApi,

    // Justice Name
    getJusticeNamesApi,
    createJusticeNameApi,
    updateJusticeNameApi,
    deleteJusticeNameApi,

    // Law Officers
    getLawOfficersApi,
    createLawOfficerApi,
    updateLawOfficerApi,
    deleteLawOfficerApi,

    // Law Officer Names
    getLawOfficerNamesApi,
    getLawOfficerNamesByOfficerApi,
    createLawOfficerNameApi,
    updateLawOfficerNameApi,
    deleteLawOfficerNameApi,

    // Respondents
    getRespondentsApi,
    createRespondentApi,
    updateRespondentApi,
    deleteRespondentApi,

    // District & Court Types
    getDistrictsApi,
    getCourtTypesApi,
    getHighCourtTypeApi,

    // Case Entry
    createHighCourtEntryApi,
    updateHighCourtEntryApi,
    createAppealCourtEntryApi,
    updateAppealCourtEntryApi,
    getCaseNumberByTypeApi,
    updateCaseEntryCommentApi,

    // Plaintiffs & Defendants
    getPlaintiffsByCaseEntryApi,
    createPlaintiffApi,
    deletePlaintiffApi,
    getDefendantsByCaseEntryApi,
    createDefendantApi,
    deleteDefendantApi,

    // Law Officer Assignment
    getAssignResponsibleOfficersApi,
    assignLawOfficerApi,
    deleteAssignLawOfficerApi,
    createResponsibleOfficersApi,
    getResponsibleOfficersApi,

    // Hearing Dates
    getHearingDatesByCaseEntryApi,
    createHearingDateApi,
    deleteHearingDateApi,

    // Documents
    getDocumentsByCaseEntryApi,
    addDocumentApi,
    deleteDocumentApi,

    // Final Result
    getFinalResultApi,
    createFinalResultApi,

    // Reports
    getSingleCaseViewApi,
    getCaseReportByIdApi,
    getAllCaseReportApi,
    getRunningDistrictCaseReportApi,
    getCloseDistrictCaseReportApi,
    getAllHighCaseReportApi,
    getRunningHighCaseReportApi,
    getCloseHighCaseReportApi,
    getAllTribunalCaseReportApi,
    getRunningTribunalCaseReportApi,
    getCloseTribunalCaseReportApi,
    getAllAppealCaseReportApi,
    getRunningAppealCaseReportApi,
    getCloseAppealCaseReportApi,
    getImportantRunningCaseApi,

    // Lawyers
    getLawyersApi,
    createLawyerApi,
    updateLawyerApi,
    deleteLawyerApi,

    // Case Summary
    getCaseSummaryApi,
    createCaseSummaryApi,
    deleteCaseSummaryApi,

    // Dashboard
    getDashboardApi,
    getNotificationApi
};